import styled from 'styled-components';
import { screenSm } from 'constants/styles/breakpoints';

export const NoVouchersContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  padding: 10px 0;
  width: 100%;
  text-align: center;
  ${screenSm} {
    padding: 20px 40px;
  }
`;

export const AwardBadge = styled.div`
  width: 64px;
  height: 64px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #ede9fd;
`;

export const Title = styled.h2`
  margin: 0;
  font-size: 20px;
  line-height: 28px;
  font-weight: 700;
  color: var(--black-dark);
`;

export const Description = styled.p`
  margin: 0;
  max-width: 500px;
  font-size: 14px;
  line-height: 20px;
  color: #57575c;
`;
